import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const ThemeCtx = createContext(null);
const STORAGE_KEY = "jr_theme";

function readInitial() {
    if (typeof window === "undefined") return "dark";
    const saved = window.localStorage?.getItem(STORAGE_KEY);
    if (saved === "light" || saved === "dark") return saved;
    // Respect OS preference on first visit
    if (window.matchMedia?.("(prefers-color-scheme: light)").matches) return "light";
    return "dark";
}

export function ThemeProvider({ children }) {
    const [theme, setTheme] = useState(readInitial);

    useEffect(() => {
        const root = document.documentElement;
        root.setAttribute("data-theme", theme);
        // Hint to the UA so native controls (scrollbars, form widgets) follow
        root.style.colorScheme = theme;
        try { window.localStorage?.setItem(STORAGE_KEY, theme); } catch (e) { /* ignore */ }
    }, [theme]);

    const toggle = useCallback(() => {
        setTheme((t) => (t === "dark" ? "light" : "dark"));
    }, []);

    return (
        <ThemeCtx.Provider value={{ theme, setTheme, toggle, isDark: theme === "dark" }}>
            {children}
        </ThemeCtx.Provider>
    );
}

export function useTheme() {
    const ctx = useContext(ThemeCtx);
    if (!ctx) return { theme: "dark", setTheme: () => {}, toggle: () => {}, isDark: true };
    return ctx;
}
